import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Box,
  BoxMetrics,
  CreateBoxRequest,
  UpdateBoxRequest,
  UpdateBoxStatusRequest,
  AddRegistrationToBoxRequest,
  BoxesListParams
} from '../types';

const { BOXES } = API_ENDPOINTS;

export const packingApi = {
  getAll: (params?: BoxesListParams) =>
    apiClient.getPaginated<Box>(BOXES.LIST, params),

  getById: (id: number) => apiClient.get<Box>(BOXES.GET(id)),

  create: (data: CreateBoxRequest) => apiClient.post<Box>(BOXES.CREATE, data),

  update: (id: number, data: UpdateBoxRequest) =>
    apiClient.put<Box>(BOXES.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(BOXES.DELETE(id)),

  metrics: () => apiClient.get<BoxMetrics>(BOXES.METRICS),

  bulkDelete: (
    params: { ids: number[] } | { all: true; filters: Partial<BoxesListParams> }
  ) => apiClient.post(BOXES.BULK_DELETE, params),

  addRegistration: (boxId: number, data: AddRegistrationToBoxRequest) =>
    apiClient.post<Box>(BOXES.ADD_REGISTRATION(boxId), data),

  removeRegistration: (boxId: number, registrationId: number) =>
    apiClient.delete(BOXES.REMOVE_REGISTRATION(boxId, registrationId)),

  updateStatus: (id: number, data: UpdateBoxStatusRequest) =>
    apiClient.patch<Box>(BOXES.UPDATE_STATUS(id), data),

  open: (id: number) => apiClient.post<Box>(BOXES.OPEN(id)),

  close: (id: number) => apiClient.post<Box>(BOXES.CLOSE(id)),

  rollback: (id: number, data: { reason: string }) =>
    apiClient.post<Box>(BOXES.ROLLBACK(id), data)
};
